import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor();

export default {
  deleteProcedimento(negociacaoId, procedimentoId) {
    return api.delete(`/negociacao/${negociacaoId}/procedimentos/${procedimentoId}`)
  },

  getProcedimentosTabelaTuss(tabelaId) {
    return api.get(`/negociacao/${tabelaId}/procedimentos/espelho`)
  },

  getProcedimentosByNegociacao(negociacaoId) {
    return api.get(`/negociacao/${negociacaoId}/procedimentos`)
  },

  getSuggestion(negociacaoId) {
    return api.get(`/negociacao/${negociacaoId}/procedimentos/suggestion`)
  },

  saveProcedimentosByNegociacao(negociacaoId, procedimentos) {
    return api.post(`/negociacao/${negociacaoId}/procedimentos`, procedimentos)
  },
}
